import classnames from 'classnames';

import style from './SelectionButtons.module.scss';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

import { SelectionButton, SelectionButtonTheme } from './SelectionButton';
import { SelectionButtonModifiers } from '@components/SelectionButtons/SelectionButton/SelectionButton';

export type ValueType<T = string | number> = Nullable<T>;

export interface SelectionButtonsProps {
    dataTest?: string;
    selectedValue: ValueType;
    values: SelectionButtonsValueParams[];
    boldFont?: boolean;
    disabled?: boolean;
    modifiers?: SelectionButtonsModifiers[];
    theme?: SelectionButtonTheme;
    columnDirection?: boolean;
    onSelect(value: ValueType): void;
}

export interface SelectionButtonsValueParams<T = string | number> {
    value: ValueType<T>;
    label: string;
    disabled?: boolean;
}

interface Props extends SelectionButtonsProps {}

export enum SelectionButtonsModifiers {
    // @ts-ignore
    FullHeight = style.root_full_height,
    // @ts-ignore
    Inline = style.inline,
    // @ts-ignore
    WithGap = style.withGap,
    // @ts-ignore
    Small = style.small,
    // @ts-ignore
    Medium = style.medium,
    // @ts-ignore
    WidePadding = style.widePadding,
    // @ts-ignore
    WhiteBg = style.whiteBg,
    // @ts-ignore
    TranslucentBg = style.translucentBg,
    // @ts-ignore
    WithoutMinHeight = style.withoutMinHeight,
    // @ts-ignore
    EqualWidth = style.equalWidth,
}

export function SelectionButtons({
    values,
    dataTest,
    selectedValue,
    boldFont,
    columnDirection,
    modifiers = [],
    theme,
    disabled,
    onSelect,
}: Props) {
    const buttonModifiers: SelectionButtonModifiers[] = [];

    modifiers?.forEach(it => {
        if (it === SelectionButtonsModifiers.Small) {
            buttonModifiers.push(SelectionButtonModifiers.Small);
        }
        if (it === SelectionButtonsModifiers.Medium) {
            buttonModifiers.push(SelectionButtonModifiers.Medium);
        }
        if (it === SelectionButtonsModifiers.WidePadding) {
            buttonModifiers.push(SelectionButtonModifiers.WidePadding);
        }
    });

    return (
        <div
            className={classnames([
                style.root,
                ...modifiers,
                columnDirection && style.root_columnDirection,
                disabled && style.disabled,
                boldFont && style.boldFont,
            ])}
        >
            {values.map(params => (
                <SelectionButton
                    modifiers={buttonModifiers}
                    theme={theme}
                    dataTest={dataTest}
                    key={params.value}
                    columnDirection={columnDirection}
                    value={params.value}
                    label={params.label}
                    disabled={params.disabled}
                    isSelected={params.value === selectedValue}
                    onSelect={disabled ? null : onSelect}
                />
            ))}
        </div>
    );
}
